/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { } from 'react';
import { Typography, Box } from '@material-ui/core';

import Accordion from '../../components/Legal/Accordion';
import FadeInContainer from '../../components/UI/FadeInContainer/FadeInContainer';
import PageTitle from '../../components/UI/PageTitle/PageTitle';

const TermsAndConditions = () => (
  <FadeInContainer maxWidth="sm">
    <Box mt={{ xs: 0, sm: 8 }} mb={10} style={{ paddingBottom: 120 }}>
      <PageTitle>
        <Box>
          Terms and Conditions of wgh.no
        </Box>
      </PageTitle>
      <Typography variant="body2" gutterBottom>
        <b>
          <Box>
            These Terms govern the use of wgh.no, and, any other related Agreement or legal relationship with the Owner in a legally binding way. Capitalized words are defined in the relevant dedicated section of this document.
          </Box>
          <br />
          <br />
          <Box>
            The User must read this document carefully.
          </Box>
          <br />
          <br />
          <Box>
            Wgh.no is provided by:
          </Box>
          <Box>
            Widerøe Ground Handling AS - Langstranda 6, 8003 BODØ, NORWAY
          </Box>
          <Box>
            Organization number: 914 426 537
          </Box>
          <Box>
            Owner contact email: personvern@wideroe.no
          </Box>
        </b>
      </Typography>

      <Accordion title={<Box>Information about wgh.no</Box>}>
        <Typography variant="body2" gutterBottom>
          <Box>
            Widerøe Ground Handling AS (WGH) offers a complete range of ground handling services to handle passengers, flights, cargo and mail.
          </Box>
        </Typography>
      </Accordion>

      <Accordion title={<Box>What the User should know at a glance</Box>}>
        <Typography variant="body2" gutterBottom>
          <Box>
            Please note that some provisions in these Terms may only apply to certain categories of Users. In particular, certain provisions may only apply to Consumers or to those Users that do not qualify as Consumers. Such limitations are always explicitly mentioned within each affected clause. In the absence of any such mention, clauses apply to all Users.
          </Box>
        </Typography>
      </Accordion>

      <Accordion title={<Box>Terms of use</Box>}>
        <Typography variant="body2" gutterBottom>
          <Box>
            Unless otherwise specified, the terms of use detailed in this section apply generally when using wgh.no. Single or additional conditions of use or access may apply in specific scenarios and in such cases are additionally indicated within this document.
          </Box>
          <br />
          <br />
          <Box>By using wgh.no, Users confirm to meet the following requirements:</Box>
          <ul>
            <li>
              <Box>There are no restrictions for Users in terms of being Consumers or Business Users;</Box>
            </li>
          </ul>
          <b><Box>Content on wgh.no</Box></b>
          <br />
          <Box>Unless where otherwise specified or clearly recognizable, all content available on wgh.no is owned or provided by the Owner or its licensors. The Owner undertakes its utmost effort to ensure that the content provided on wgh.no infringes no applicable legal provisions or third-party rights. However, it may not always be possible to achieve such a result. In such cases, without prejudice to any legal prerogatives of Users to enforce their rights, Users are kindly asked to preferably report related complaints using the contact details provided in this document.</Box>
          <br />
          <br />
          <b><Box>Rights regarding content on wgh.no - All rights reserved</Box></b>
          <br />
          <Box>The Owner holds and reserves all intellectual property rights for any such content. Users may not therefore use such content in any way that is not necessary or implicit in the proper use of the Service. In particular, but without limitation, Users may not copy, download, share (beyond the limits set forth below), modify, translate, transform, publish, transmit, sell, sublicense, edit, transfer/assign to third parties or create derivative works from the content available on wgh.no, nor allow any third party to do so through the User or their device, even without the Users knowledge. Where explicitly stated on wgh.no, the User may download, copy and/or share some content available through wgh.no for its sole personal and non-commercial use and provided that the copyright attributions and all the other attributions requested by the Owner are correctly implemented. Any applicable statutory limitation or exception to copyright shall stay unaffected.</Box>
          <br />
          <br />
          <b><Box>Access to external resources</Box></b>
          <br />
          <Box>Through wgh.no Users may have access to external resources provided by third parties. Users acknowledge and accept that the Owner has no control over such resources and is therefore not responsible for their content and availability. Conditions applicable to any resources provided by third parties, including those applicable to any possible grant of rights in content, result from each such third parties’ terms and conditions or, in the absence of those, applicable statutory law.</Box>
          <br />
          <br />
          <b><Box>Acceptable use</Box></b>
          <br />
          <Box>Wgh.no and the Service may only be used within the scope of what they are provided for, under these Terms and applicable law. Users are solely responsible for making sure that their use of wgh.no and/or the Service violates no applicable law, regulations or third-party rights. Therefore, the Owner reserves the right to take any appropriate measure to protect its legitimate interests including by denying Users access to wgh.no or the Service, terminating contracts, reporting any misconduct performed through wgh.no or the Service to the competent authorities – such as judicial or administrative authorities - whenever Users engage or are suspected to engage in any of the following activities:</Box>
          <ul>
            <li>
              <Box>violate laws, regulations and/or these Terms;</Box>
            </li>
            <li>
              <Box>infringe any third-party rights;</Box>
            </li>
            <li>
              <Box>considerably impair the Owners legitimate interests;</Box>
            </li>
            <li>
              <Box>violate laws, regulations and/or these Terms;</Box>
            </li>
          </ul>
        </Typography>
      </Accordion>

      <Accordion title={<Box>Liability and indemnification</Box>}>
        <Typography variant="body2" gutterBottom>
          <b>
            <Box>
              Australian Users - Limitation of liability
            </Box>
          </b>
          <br />
          <Box>Nothing in these Terms excludes, restricts or modifies any guarantee, condition, warranty, right or remedy which the User may have under the Competition and Consumer Act 2010 (Cth) or any similar State and Territory legislation and which cannot be excluded, restricted or modified (non-excludable right). To the fullest extent permitted by law, our liability to the User, including liability for a breach of a non-excludable right and liability which is not otherwise excluded under these Terms of Use, is limited, at the Owner’s sole discretion, to the re-performance of the services or the payment of the cost of having the services supplied again.</Box>
          <br />
          <br />
          <b>
            <Box>
              US Users - Disclaimer of Warranties
            </Box>
          </b>
          <br />
          <Box>
            Wgh.no is provided strictly on an “as is” and “as available” basis. Use of the Service is at Users’ own risk. To the maximum extent permitted by applicable law, the Owner expressly disclaims all conditions, representations, and warranties — whether express, implied, statutory or otherwise, including, but not limited to, any implied warranty of merchantability, fitness for a particular purpose, or non-infringement of third-party rights. No advice or information, whether oral or written, obtained by user from owner or through the Service will create any warranty not expressly stated herein. Without limiting the foregoing, the Owner, its subsidiaries, affiliates, licensors, officers, directors, agents, co-branders, partners, suppliers and employees do not warrant that the content is accurate, reliable or correct; that the Service will meet Users’ requirements; that the Service will be available at any particular time or location, uninterrupted or secure; that any defects or errors will be corrected; or that the Service is free of viruses or other harmful components. Any content downloaded or otherwise obtained through the use of the Service is downloaded at users own risk and users shall be solely responsible for any damage to Users’ computer system or mobile device or loss of data that results from such download or Users’ use of the Service. The Owner does not warrant, endorse, guarantee, or assume responsibility for any product or service advertised or offered by a third party through the Service or any hyperlinked website or service, and the Owner shall not be a party to or in any way monitor any transaction between Users and third-party providers of products or services. The Service may become inaccessible or it may not function properly with Users’ web browser, mobile device, and/or operating system. The owner cannot be held liable for any perceived or actual damages arising from Service content, operation, or use of this Service. Federal law, some states, and other jurisdictions, do not allow the exclusion and limitations of certain implied warranties. The above exclusions may not apply to Users. This Agreement gives Users specific legal rights, and Users may also have other rights which vary from state to state. The disclaimers and exclusions under this agreement shall not apply to the extent prohibited by applicable law.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              US Users - Limitations of liability
            </Box>
          </b>
          <br />
          <Box>
            To the maximum extent permitted by applicable law, in no event shall the Owner, and its subsidiaries, affiliates, officers, directors, agents, co-branders, partners, suppliers and employees be liable for any indirect, punitive, incidental, special, consequential or exemplary damages, including without limitation damages for loss of profits, goodwill, use, data or other intangible losses, arising out of or relating to the use of, or inability to use, the Service; andany damage, loss or injury resulting from hacking, tampering or other unauthorized access or use of the Service or User account or the information contained therein; any errors, mistakes, or inaccuracies of content; personal injury or property damage, of any nature whatsoever, resulting from User access to or use of the Service; any unauthorized access to or use of the Owner’s secure servers and/or any and all personal information stored therein; any interruption or cessation of transmission to or from the Service; any bugs, viruses, trojan horses, or the like that may be transmitted to or through the Service; any errors or omissions in any content or for any loss or damage incurred as a result of the use of any content posted, emailed, transmitted, or otherwise made available through the Service; and/or the defamatory, offensive, or illegal conduct of any User or third party. In no event shall the Owner, and its subsidiaries, affiliates, officers, directors, agents, co-branders, partners, suppliers and employees be liable for any claims, proceedings, liabilities, obligations, damages, losses or costs in an amount exceeding the amount paid by User to the Owner hereunder in the preceding 12 months, or the period of duration of this agreement between the Owner and User, whichever is shorter. This limitation of liability section shall apply to the fullest extent permitted by law in the applicable jurisdiction whether the alleged liability is based on contract, tort, negligence, strict liability, or any other basis, even if company has been advised of the possibility of such damage. Some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, therefore the above limitations or exclusions may not apply to User. The terms give User specific legal rights, and User may also have other rights which vary from jurisdiction to jurisdiction. The disclaimers, exclusions, and limitations of liability under the terms shall not apply to the extent prohibited by applicable law.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              US Users - Indemnification
            </Box>
          </b>
          <br />
          <Box>
            The User agrees to defend, indemnify and hold the Owner and its subsidiaries, affiliates, officers, directors, agents, co-branders, partners, suppliers and employees harmless from and against any and all claims or demands, damages, obligations, losses, liabilities, costs or debt, and expenses, including, but not limited to, legal fees and expenses, arising from User’s use of and access to the Service, including any data or content transmitted or received by User; User’s violation of these terms, including, but not limited to, User’s breach of any of the representations and warranties set forth in these terms; User’s violation of any third-party rights, including, but not limited to, any right of privacy or intellectual property rights; User’s violation of any statutory law, rule, or regulation; any content that is submitted from User’s account, including third party access with User’s unique username, password or other security measure, if applicable, including, but not limited to, misleading, false, or inaccurate information; User’s wilful misconduct; or statutory provision by User or its affiliates, officers, directors, agents, co-branders, partners, suppliers and employees to the extent allowed by applicable law.
          </Box>
        </Typography>
      </Accordion>

      <Accordion title={<Box>Common provisions</Box>}>
        <Typography variant="body2" gutterBottom>
          <b>
            <Box>
              No Waiver
            </Box>
          </b>
          <br />
          <Box>
            The Owner’s failure to assert any right or provision under these Terms shall not constitute a waiver of any such right or provision. No waiver shall be considered a further or continuing waiver of such term or any other term.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Service interruption
            </Box>
          </b>
          <br />
          <Box>
            To ensure the best possible service level, the Owner reserves the right to interrupt the Service for maintenance, system updates or any other changes, informing the Users appropriately. Within the limits of law, the Owner may also decide to suspend or terminate the Service altogether. If the Service is terminated, the Owner will cooperate with Users to enable them to withdraw Personal Data or information in accordance with applicable law. Additionally, the Service might not be available due to reasons outside the Owner’s reasonable control, such as “force majeure” (eg. labor actions, infrastructural breakdowns or blackouts etc).
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Service reselling
            </Box>
          </b>
          <br />
          <Box>
            Users may not reproduce, duplicate, copy, sell, resell or exploit any portion of wgh.no and of its Service without the Owner’s express prior written permission, granted either directly or through a legitimate reselling programme.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Privacy policy
            </Box>
          </b>
          <br />
          <Box>
            To learn more about the use of their Personal Data, Users may refer to the privacy policy of wgh.no.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Intellectual property rights
            </Box>
          </b>
          <br />
          <Box>
            Without prejudice to any more specific provision of these Terms, any intellectual property rights, such as copyrights, trademark rights, patent rights and design rights related to wgh.no are the exclusive property of the Owner or its licensors and are subject to the protection granted by applicable laws or international treaties relating to intellectual property. All trademarks — nominal or figurative — and all other marks, trade names, service marks, word marks, illustrations, images, or logos appearing in connection with wgh.no are, and remain, the exclusive property of the Owner or its licensors and are subject to the protection granted by applicable laws or international treaties related to intellectual property.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Changes to these Terms
            </Box>
          </b>
          <br />
          <Box>
            The Owner reserves the right to amend or otherwise modify these Terms at any time. In such cases, the Owner will appropriately inform the User of these changes. Such changes will only affect the relationship with the User for the future. The continued use of the Service will signify the User’s acceptance of the revised Terms. If Users do not wish to be bound by the changes, they must stop using the Service. Failure to accept the revised Terms, may entitle either party to terminate the Agreement. The applicable previous version will govern the relationship prior to the User's acceptance. The User can obtain any previous version from the Owner. If required by applicable law, the Owner will specify the date by which the modified Terms will enter into force.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Assignment of contract
            </Box>
          </b>
          <br />
          <Box>
            The Owner reserves the right to transfer, assign, dispose of by novation, or subcontract any or all rights or obligations under these Terms, taking the User’s legitimate interests into account. Provisions regarding changes of these Terms will apply accordingly. Users may not assign or transfer their rights or obligations under these Terms in any way, without the written permission of the Owner.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Contacts
            </Box>
          </b>
          <br />
          <Box>
            All communications relating to the use of wgh.no must be sent using the contact information stated in this document.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Severability
            </Box>
          </b>
          <br />
          <Box>
            Should any provision of these Terms be deemed or become invalid or unenforceable under applicable law, the invalidity or unenforceability of such provision shall not affect the validity of the remaining provisions, which shall remain in full force and effect.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              US Users
            </Box>
          </b>
          <br />
          <Box>
            Any such invalid or unenforceable provision will be interpreted, construed and reformed to the extent reasonably required to render it valid, enforceable and consistent with its original intent. These Terms constitute the entire Agreement between Users and the Owner with respect to the subject matter hereof, and supersede all other communications, including but not limited to all prior agreements, between the parties with respect to such subject matter. These Terms will be enforced to the fullest extent permitted by law.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              EU Users
            </Box>
          </b>
          <br />
          <Box>
            Should any provision of these Terms be or be deemed void, invalid or unenforceable, the parties shall do their best to find, in an amicable way, an agreement on valid and enforceable provisions thereby substituting the void, invalid or unenforceable parts. In case of failure to do so, the void, invalid or unenforceable provisions shall be replaced by the applicable statutory provisions, if so permitted or stated under the applicable law. Without prejudice to the above, the nullity, invalidity or the impossibility to enforce a particular provision of these Terms shall not nullify the entire Agreement, unless the severed provisions are essential to the Agreement, or of such importance that the parties would not have entered into the contract if they had known that the provision would not be valid, or in cases where the remaining provisions would translate into an unacceptable hardship on any of the parties.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Governing law
            </Box>
          </b>
          <br />
          <Box>
            These Terms are governed by the law of the place where the Owner is based, as disclosed in the relevant section of this document, without regard to conflict of laws principles.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Exception for European Consumers
            </Box>
          </b>
          <br />
          <Box>
            However, regardless of the above, if the User qualifies as a European Consumer and has their habitual residence in a country where the law provides for a higher consumer protection standard, such higher standards shall prevail.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Venue of jurisdiction
            </Box>
          </b>
          <br />
          <Box>
            The exclusive competence to decide on any controversy resulting from or connected to these Terms lies with the courts of the place where the Owner is based, as displayed in the relevant section of this document.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Exception for European Consumers
            </Box>
          </b>
          <br />
          <Box>
            The above does not apply to any Users that qualify as European Consumers, nor to Consumers based in Switzerland, Norway or Iceland.
          </Box>
        </Typography>
      </Accordion>
      <Accordion title={<Box>Definitions and legal references</Box>}>
        <Typography variant="body2" gutterBottom>
          <b>
            <Box>
              Wgh.no (or this Application)
            </Box>
          </b>
          <br />
          <Box>
            The property that enables the provision of the Service.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Agreement
            </Box>
          </b>
          <br />
          <Box>
            Any legally binding or contractual relationship between the Owner and the User, governed by these Terms.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Business User
            </Box>
          </b>
          <br />
          <Box>
            Any User that does not qualify as a Consumer.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              European (or Europe)
            </Box>
          </b>
          <br />
          <Box>
            Applies where a User is physically present or has their registered offices within the EU, regardless of nationality.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Owner (or We)
            </Box>
          </b>
          <br />
          <Box>
            Indicates the natural person(s) or legal entity that provides wgh.no and/or the Service to Users.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Service
            </Box>
          </b>
          <br />
          <Box>
            The service provided by wgh.no as described in these Terms and on wgh.no.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Terms
            </Box>
          </b>
          <br />
          <Box>
            All provisions applicable to the use of wgh.no and/or the Service as described in this document, including any other related documents or agreements, and as updated from time to time.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              User (or You)
            </Box>
          </b>
          <br />
          <Box>
            Indicates any natural person or legal entity using wgh.no.
          </Box>
          <br />
          <br />
          <b>
            <Box>
              Consumer
            </Box>
          </b>
          <br />
          <Box>
            Any User qualifying as a natural person who accesses goods or services for personal use, or more generally, acts for purposes outside their trade, business, craft or profession.
          </Box>
        </Typography>
      </Accordion>

    </Box>
  </FadeInContainer>
);

export default TermsAndConditions;
